"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AdditionalInformationItem_1 = __importDefault(require("@features/ItemCommon/components/common/AdditionalInformationItem"));
var react_i18next_1 = require("react-i18next");
var AdditionalInformation_1 = require("@features/SearchPage/SearchResult/Table/AdditionalInformation");
var implioFilters_1 = require("@/react-app/features/Search/FilterBar/FilterSideBar/implioFilters");
function ItemCategoryReadOnly(_a) {
    var _b, _c, _d, _e;
    var job = _a.job, angularJsDependencies = _a.angularJsDependencies, renderTag = _a.renderTag, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    var remoteIdDomain = ((_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.remoteId.domain) || '';
    var contentCategoryName = ((_e = (_d = (_c = job === null || job === void 0 ? void 0 : job.ad) === null || _c === void 0 ? void 0 : _c.current.content) === null || _d === void 0 ? void 0 : _d.category) === null || _e === void 0 ? void 0 : _e.name) || '';
    var sanitizedContentCategoryName = (0, react_1.useMemo)(function () {
        return (0, AdditionalInformation_1.sanitizeValue)(job, 'current.content.category.name');
    }, [job]);
    return (react_1.default.createElement(react_1.default.Fragment, null, contentCategoryName && (react_1.default.createElement(AdditionalInformationItem_1.default, { titleTranslationKey: "SEARCH.ITEM.SEARCH_CATEGORY_TOOLTIP_REACT", label: t('ITEM.CATEGORY'), value: contentCategoryName, sanitizedValue: sanitizedContentCategoryName, angularJsDependencies: angularJsDependencies, renderTag: renderTag || 'link', searchText: implioFilters_1.filterKey.categoryName, domain: remoteIdDomain, automationListsPermission: automationListsPermission }))));
}
exports.default = ItemCategoryReadOnly;
